import React from 'react';
import { Link } from 'react-router-dom';

const ServicesPage = () => {
  const servicesList = [
    {
      title: "Management Consulting",
      subtitle: "Operational Excellence & Corporate Structuring",
      description: "Comprehensive organizational assessment, restructuring, workflow optimization, leadership governance, and operational auditing tailored to high-growth market demands.",
      image: "img/ser-1.avif",
      features: [
        "Organizational Restructuring & Governance",
        "Process & Operational Workflow Optimization",
        "Performance Management Systems & KPIs",
        "Change Management & Strategic Advisory"
      ]
    },
    {
      title: "Market Research & Intelligence",
      subtitle: "Data-Driven Insights & Feasibility Assessment",
      description: "Rigorous feasibility studies, market entry analyses, competitor benchmark reports, pricing intelligence, and consumer behavior evaluations for informed commercial decisions.",
      image: "img/img-6.avif",
      features: [
        "Feasibility & Economic Viability Studies",
        "Competitor Benchmarking & Market Intelligence",
        "Demand Forecasting & Supply Dynamics",
        "Regulatory Landscape & Country Risk Assessment"
      ]
    },
    {
      title: "Business Strategy & Expansion",
      subtitle: "Scalable Growth & Global Reach",
      description: "Developing robust corporate growth frameworks, revenue model design, cross-border expansion roadmaps, and strategic partnership structures.",
      image: "img/ser-3.avif",
      features: [
        "Corporate Growth & Revenue Modeling",
        "Cross-Border Expansion Planning",
        "Joint Venture & Strategic Alliances",
        "Risk Mitigation & Commercial Planning"
      ]
    },
    {
      title: "Marketing Consultancy",
      subtitle: "Brand Positioning & Go-To-Market Execution",
      description: "High-impact brand positioning, integrated multi-channel marketing campaigns, customer acquisition strategies, and commercial value proposition design.",
      image: "img/ser-4.avif",
      features: [
        "Brand Identity & Positioning Architecture",
        "Omnichannel Go-To-Market Strategies",
        "Customer Lifetime Value Optimization",
        "Digital & Traditional Campaign Planning"
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-[#faeee2]">
      <section className="relative pt-44 pb-20 md:pt-52 md:pb-28 overflow-hidden bg-brand-deepBrown">
        <div className="absolute inset-0 z-0">
          <img 
            src="img/ser-5.avif" 
            alt="Capilano Advisory Team" 
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/75 backdrop-blur-[2px]"></div>
        </div>
        
        <div className="relative z-10 max-w-4xl mx-auto px-6 text-center" data-aos="fade-up">
          <span className="inline-block px-5 py-1.5 rounded-full border border-brand-orange/40 bg-brand-orange/10 text-brand-orange text-xs md:text-sm font-bold tracking-widest uppercase mb-6 backdrop-blur-sm">
            WHAT WE OFFER
          </span>
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-serif font-bold text-white mb-6 leading-tight">
            Our <span className="text-brand-orange">Services</span>
          </h1>
          <p className="text-base md:text-lg text-[#faeee2]/90 leading-relaxed max-w-2xl mx-auto">
            Unleash the full potential of your business with our expert consulting services designed to drive transformative performance and accelerate growth.
          </p>
        </div>
      </section>

      <section className="py-20 px-6">
        <div className="max-w-7xl mx-auto space-y-20">
          {servicesList.map((service, idx) => (
            <div 
              key={idx} 
              className={`flex flex-col lg:flex-row gap-12 items-center bg-white p-8 md:p-10 rounded-3xl border border-[#a17644]/20 shadow-md ${
                idx % 2 !== 0 ? 'lg:flex-row-reverse' : ''
              }`}
              data-aos="fade-up"
            >
              <div className="w-full lg:w-1/2">
                <div className="rounded-2xl overflow-hidden shadow-xl border-2 border-[#f2decb] bg-[#f2decb] h-[320px] md:h-[380px]">
                  <img 
                    src={service.image} 
                    alt={service.title} 
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              
              <div className="w-full lg:w-1/2">
                <h3 className="text-3xl font-serif font-bold text-brand-deepBrown mb-2">
                  {service.title}
                </h3>
                <p className="text-xs font-bold text-brand-orange uppercase tracking-wider mb-4">
                  {service.subtitle}
                </p>
                <p className="text-brand-grayBrown leading-relaxed text-sm md:text-base mb-6">
                  {service.description}
                </p>
                
                <div className="bg-[#faeee2] p-5 rounded-xl border border-[#f2decb] mb-8">
                  <ul className="space-y-3">
                    {service.features.map((item, fIdx) => (
                      <li key={fIdx} className="text-xs md:text-sm font-semibold text-brand-darkBrown flex items-center gap-3">
                        <span className="text-brand-orange font-bold">✓</span> {item}
                      </li>
                    ))}
                  </ul>
                </div>

                <Link 
                  to="/contact" 
                  className="inline-flex items-center justify-center py-3.5 px-8 rounded-full bg-brand-darkBrown text-white font-bold hover:bg-brand-orange transition-colors duration-300 text-xs uppercase tracking-wider shadow-md"
                >
                  Consult Our Experts
                </Link>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="py-20 bg-[#f2decb]/80 border-t border-[#a17644]/20 px-6 text-center">
        <div className="max-w-4xl mx-auto" data-aos="zoom-in">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-deepBrown mb-6">
            Ready to Accelerate Your Business Growth?
          </h2>
          <p className="text-brand-grayBrown text-base md:text-lg mb-8 max-w-2xl mx-auto">
            Get tailored market research and strategic guidance custom-crafted for your organization.
          </p>
          <Link
            to="/contact"
            className="inline-block px-8 py-4 bg-brand-orange text-white font-semibold rounded-full hover:bg-brand-darkBrown transition-colors duration-300 shadow-md text-sm uppercase tracking-wider"
          >
            Schedule A Strategy Call
          </Link>
        </div>
      </section>
    </div>
  );
};

export default ServicesPage;